import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { STATIC } from '../../lib/queryPresets';
import {
  type EditableFeature,
  type FeatureOverride,
  listFeatureOverrides,
  updateFeatureOverride,
} from '../../services/featureOverrides/featureOverridesService';
import { useAuthStore } from '../../store/useAuthStore';
import type { CollaboratorRole } from '../../services/auth/permissions';

export const featureOverridesKeys = {
  all: ['feature_overrides'] as const,
};

export function useFeatureOverrides() {
  const isInitialized = useAuthStore((s) => s.isInitialized);
  const session = useAuthStore((s) => s.session);

  return useQuery({
    ...STATIC,
    queryKey: featureOverridesKeys.all,
    queryFn: listFeatureOverrides,
    enabled: isInitialized && !!session,
  });
}

export function useUpdateFeatureOverride() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ feature, allowedRoles }: {
      feature: EditableFeature;
      allowedRoles: CollaboratorRole[];
    }) => updateFeatureOverride(feature, allowedRoles),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: featureOverridesKeys.all });
    },
  });
}

export type { FeatureOverride, EditableFeature };
